module.exports = __webpack_public_path__ + "static/media/loading_ring.b864f857.svg";